import { render, staticRenderFns } from "./Csrf.vue?vue&type=template&id=4ca5a666"
import script from "./Csrf.vue?vue&type=script&lang=js"
export * from "./Csrf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports